import { styled } from "@compiled/react";

export const EditContainer = styled.div({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    borderRadius: "4px",
    margin: "0px 8px",
    transition: "transform 1s ease-in",
    maxWidth: "406px",
    gap: "9px",
    border: "2px solid #4C9AFF",
    height: "32px",
    padding: "0px 12px"
});

export const IconBlock = styled.div({
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center"
});

export const Input = styled.input({
    flex: 1,
    border: "none",
    fontSize: "14px",
    fontFamily:
        "Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, 'Noto Sans', Ubuntu, 'Droid Sans', 'Helvetica Neue', sans-serif !important",
    [":focus"]: {
        outline: "none"
    }
});

export const Name = styled.span({
    color: "#172B4D",
    fontSize: "14px",
    lineHeight: "20px",
    fontStyle: "normal",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    height: "20px",
    maxWidth: "180px",
    fontFamily:
        "Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, 'Noto Sans', Ubuntu, 'Droid Sans', 'Helvetica Neue', sans-serif !important"
});
